<template lang="html">
  <div class="draft-invite">
    <h2>Draft Invite</h2>

    <div v-if="draft && draft.name">
      <h3>{{ draft.name }}</h3>

      <div>
        <span>Rounds: <b>{{ draft.rounds }}</b></span>
      </div>

      <div>
        <span>Type: <b>{{ draft.type }}</b></span>
      </div>

      <div>
        <span>Pick Duration: <b>{{ draft.duration }}</b></span>
      </div>

      <div>
        <span>Rankings: <b>{{ draft.baseRanking.label }}</b></span>
      </div>

      <br>
    </div>

    <form @submit.prevent="join">
      <h4>Choose a team name</h4>

      <input
        type="text"
        required
        maxlength="20"
        placeholder="Team name"
        v-model="teamName"
      >

      <p class="error" v-if="errorMessage">{{ errorMessage }}</p>

      <button type="submit" :disabled="running">Submit</button>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      errorMessage: null,
      running: false,
      teamName: '',
    };
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
      code: ({ route }) => route.query.code,
    }),
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      this.$store.dispatch('draft/LOAD_DRAFT_BY_CODE', this.code);
    },

    join() {
      this.running = true;

      this.$store.dispatch('draft/JOIN_DRAFT', { draftId: this.code, teamName: this.teamName })
        .then(({ data: { draftId } }) => {
          this.goToDraft(draftId);
        })
        .catch(({ response: { data: { message, draftId } } }) => {
          this.errorMessage = message;

          if (draftId) {
            this.goToDraft(draftId);
          }
        });
    },

    goToDraft(draftId) {
      setTimeout(() => {
        this.$router.replace(`/draft/${draftId}`);
      }, 500);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-invite {
    @include container;
  }
</style>
